import {
  actionCreator,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import type { FutureStateDrafts } from 'transformations/futureStatePage/futureStateDrafts';
import type { DraftFutureStateChangesPayload } from './command';

export type RejectedBatch = {
  futureStateId: ArdoqId;
  basedOnVersion: number;
  reason: string;
  changes: DraftFutureStateChangesPayload;
};

export const draftBatchRejected = actionCreator<RejectedBatch>(
  '[futureStateDraftClaims] draft batch rejected'
);

const replaceRejectedBatch = (
  _: RejectedBatch | null,
  rejected: RejectedBatch
): RejectedBatch | null => rejected;

/** The last batch the backend refused to render. Used for chat feedback only. */
export const rejectedBatch$ = persistentReducedStream<RejectedBatch | null>(
  'futureStateRejectedBatch$',
  null,
  [reducer(draftBatchRejected, replaceRejectedBatch)]
);

export const isCurrentRejection = (
  rejected: RejectedBatch | null,
  { futureStateId, latestDraftVersion }: FutureStateDrafts
): rejected is RejectedBatch =>
  rejected?.futureStateId === futureStateId &&
  rejected.basedOnVersion === latestDraftVersion;
